@if (hasCreateButton) {
  <div class="auto mb-4 flex justify-start">
    <button
      (click)="openCreateModal()"
      class="btn btn-circle btn-primary float-left mt-10 ml-10"
    >
      <svg
        class="inline-block h-6 w-6 stroke-current"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 6v12m6-6H6"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        ></path>
      </svg>
    </button>
  </div>
}
<div class="overflow-x-auto">
  <table class="table">
    <thead>
      <tr>
        <th>
          <label>
            <input
              (change)="toggleSelectAll()"
              class="checkbox"
              type="checkbox"
            />
          </label>
        </th>
        @for (column of columns; track column) {
          <th>{{ column.label }}</th>
        }
        <th></th>
        <!-- For the details button column -->
      </tr>
    </thead>
    <tbody>
      <ng-content></ng-content>
    </tbody>
    <tfoot>
      <tr>
        @for (_ of columns; track _) {
          <th></th>
        }
        <th></th>
        <th></th>
      </tr>
    </tfoot>
  </table>
</div>
